export default "__VITE_ASSET__CBTyfb8T__"